import React, { useState, useEffect } from 'react'
import { Alert, Box, Button, Modal, Snackbar, TextField, Tooltip, Typography } from '@mui/material';


import { useSelector, useDispatch } from 'react-redux';


import store, { rootReducers } from '../store/index'
import { REGISTER_USER_action } from '../store/actions/userAction';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { FaGooglePlusG } from "react-icons/fa";
import axios from 'axios';
import CryptoJS from "crypto-js";

const mapStateToProps = (state) => {
    return {
        pageParameters: state.pageReducer
    };
}
// const store = createStore(rootReducers);

const Register = ({ navigation }) => {
    let [actualVersion, setActualVersion] = useState(75);
    let [actualVersion2, setActualVersion2] = useState(0);
    let [openUpdateSnackbar, setOpenUpdateSnackbar] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const location = useLocation();
    const [loading, setLoading] = useState(false); // Estado para la pantalla de carga
    let [msgError, setMsgError] = useState("")
    let [dataFromURL, setDataFromURL] = useState('');
    let [openModal, setOpenModal] = useState(false)


    let [publicKey, setPublicKey] = useState('');
    let statePublicKey = '';
    let [privateKey, setPrivateKey] = useState('');
    let statePrivateKey = '';
    let [userID, setUserID] = useState('');
    let stateUserID = '';

    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [showAlert, setShowAlert] = useState(false);

    const navigate = useNavigate();

    const phoneValidation = () => {

    }


    async function getUserInfo() {

        const token = localStorage.getItem('jwt_token');

        const data = {
            // "UserID": 5051, // Modo desarrollo
            "UserID": 1080, // Modo produccion
        }
        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'

        await axios.post('https://socializeapi.azurewebsites.net/api/GetUser', { data: data_encripted }, {
            headers
        })
            .then(response => {
                // Check if both values are valid numbers before comparing
                const currentVersion = Number(actualVersion);
                const serverVersion = Number(response.data.telephone);

                if (!isNaN(currentVersion) && !isNaN(serverVersion) && currentVersion !== serverVersion) {
                    setActualVersion2(response.data.telephone);
                    console.log("version diferente");
                    // setShowModalActualizacionPendiente(true);
                    setOpenUpdateSnackbar(true); // Mostrar el snackbar
                }
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }


    async function RegisterAction() {
        if (name.trim() === '' || email.trim() === '' || phone.trim() === '' || password.trim() === '') {
            setShowAlert(true);
        } else {
            setLoading(true); // Mostrar pantalla de carga
            const headers = 'content-type: application/json; charset=utf-8'
            const data = {
                "nameUser": name,
                "pass": password,
                "telephone": phone,
                "email": email
            }


            // store.dispatch(REGISTER_USER_action([name, email, phone, password]))
            try {
                await axios.post('https://socializeapi.azurewebsites.net/api/RegisterUser', data, { headers })
                    .then(async response => {

                        if (response.data == "Ya existe un usuario registrado con ese mail.") {
                            //setMsgError(response.data); // Asigna el mensaje del backend a la variable
                            setOpenModal(true)
                        } else {
                            setUserID(response.data.userID);
                            stateUserID = response.data.userID;

                            if (!navigator.userAgent.includes("Android")) {


                                await obtenerVAPID();
                                await subscribeToPushNotifications(response.data.userID);
                            }

                            navigate('/login');
                        }

                    })
                    .catch(error => {
                        console.log(`Error obteniendo datos: ${error}`);
                    });

            } catch (error) {
                console.log(`Error obteniendo datos: ${error}`);
            } finally {
                setLoading(false); // Ocultar pantalla de carga
            }

        }

    }




    async function obtenerVAPID() {
        const headers = 'content-type: application/json; charset=utf-8'

        await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
            .then(response => {
                console.log("response obtenerVAPID")
                console.log(response)
                if (response.data !== null) {
                    setPublicKey(response.data.keys.publicKey)
                    statePublicKey = response.data.keys.publicKey
                    setPrivateKey(response.data.keys.privateKey)
                    statePrivateKey = response.data.keys.privateKey
                }

            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }


    async function subscribeToPushNotifications(userId) {
        console.log("subscribeToPushNotifications user id")
        console.log(userId)
        const userAgent = navigator.userAgent;
        console.log('Service Worker supported:', 'serviceWorker' in navigator);
        console.log('Push Manager supported:', 'PushManager' in window);

        const registration = await navigator.serviceWorker.register('/service-worker.js');

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.error('Permission for notifications was denied.');
            return;
        }


        // Verificar si ya hay una suscripción existente
        let subscription = await registration.pushManager.getSubscription();


        console.log("subscription");
        console.log(subscription);



        // Si ya hay una suscripción, desuscribirse
        if (subscription) {
            await subscription.unsubscribe();
            console.log('Successfully unsubscribed from the existing subscription.');
        }



        validateApplicationServerKey(statePublicKey)
        try {
            const addsubscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(statePublicKey)
            });

            console.log("addsubscription object:", JSON.stringify(addsubscription));


            // Validar que `keys` esté definido antes de usarlo
            if (!addsubscription.getKey('p256dh') || !addsubscription.getKey('auth')) {
                throw new Error("Keys are undefined in the subscription object");
            }

            const data = {
                Endpoint: addsubscription.endpoint,
                P256dh: addsubscription.getKey('p256dh'),
                Auth: addsubscription.getKey('auth'),
                UserId: userId
            }

            const jsonData = JSON.stringify(data);
            const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

            console.log("userAgent")
            console.log(userAgent)
            // Enviar la suscripción al backend
            await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${userId}`, {
                Endpoint: addsubscription.endpoint,
                // Keys: {
                //   p256dh: addsubscription.getKey('p256dh'),
                //   auth: addsubscription.getKey('auth')
                // }
                Keys: {
                    p256dh: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('p256dh')))),
                    auth: btoa(String.fromCharCode(...new Uint8Array(addsubscription.getKey('auth'))))
                },
                PublicKey: statePublicKey,
                PrivateKey: statePrivateKey,
                UserAgent: userAgent

            });
        } catch (error) {
            console.error('Failed to subscribe:', error.message || error);
        }



        //   await axios.post(`https://socializeapi.azurewebsites.net/api/register-push?userId=${userId}`, {
        //     endpoint: addsubscription.endpoint,
        //     keys: {
        //       p256dh: addsubscription.getKey('p256dh'),
        //       auth: addsubscription.getKey('auth')
        //     }
        //   });
        // } catch (error) {
        //   console.error('Failed to subscribe:', error.message || error);
        // }



    }

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
    }

    async function validateApplicationServerKey(applicationServerKey) {
        try {
            const key = await crypto.subtle.importKey(
                'raw',
                urlBase64ToUint8Array(applicationServerKey),
                { name: 'ECDSA', namedCurve: 'P-256' },
                true,
                []
            );
            console.log('La clave es válida:', key);
            return true;
        } catch (error) {
            console.error('Clave no válida:', error);
            return false;
        }
    }


    function decryptData(encryptedText) {

        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    const getDataFromURL = () => {
        // Obtener el parámetro de la URL
        const queryParams = new URLSearchParams(location.search);
        const encryptedValue = queryParams.get('data');

        if (encryptedValue != "" && encryptedValue != null & encryptedValue != undefined) {

            return encryptedValue;
        } else {
            return "";
        }
    };


    useEffect(() => {
        const validateToken = async () => {
            const dataFromURL = getDataFromURL();

            if (dataFromURL !== "") {
                // console.log("dataFromURL")
                // console.log(dataFromURL)
                // let decripted_response = decryptData(dataFromURL);

                // setDataFromURL(dataFromURL);


                const secretKey = "EsteEsUnEjemploDeClaveDe32Caracteres!"; // Clave compartida entre origen y destino

                // Desencriptar el valor
                const decryptedValue = CryptoJS.AES.decrypt(dataFromURL, secretKey).toString(CryptoJS.enc.Utf8);

                console.log("decryptedValue registro")
                console.log(decryptedValue)
                localStorage.setItem('eventID', decryptedValue)

                setDataFromURL(dataFromURL)

            }
        };

        validateToken();

    }, []);

    useEffect(() => {
        if (navigator.userAgent.includes("Android")) {

            getUserInfo();
        }

        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // Estilos en línea como objetos de JavaScript
    const styles = {
        loadingScreen: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        loadingModal: {
            backgroundColor: 'white',
            padding: '20px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
        },
        loadingSpinner: {
            margin: '20px auto',
            width: '40px',
            height: '40px',
            border: '4px solid transparent',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
        },
        '@keyframes spin': {
            from: {
                transform: 'rotate(0deg)',
            },
            to: {
                transform: 'rotate(360deg)',
            },
        },
    };

    return (

        <div style={{
            display: 'flex',
            height: '100vh',
        }}>

            {loading && (
                <div className="loading-screen">
                    <div className="loading-modal">
                        <p>Registrando usuario, por favor espere...</p>
                        <div className="loading-spinner"></div>
                    </div>
                </div>
            )}

            {/* Formulario */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: (isLargeScreen ? '60%' : '100%'),
                minWidth: (isLargeScreen && 500),
            }}>

                <p style={{
                    // color: '#009688',
                    color: (showAlert ? '#DC3545' : '#009688'),
                    fontWeight: '500',
                    fontSize: `clamp(32px, 4vw, 64px)`,
                    marginBottom: 64
                }}>Registrate</p>

                {/* Formulario */}
                <div style={{ width: (isLargeScreen ? '50%' : '80%'), display: 'flex', flexDirection: 'column' }}>

                    {/* GOOGLE */}
                    {/* <Tooltip title="Haga click aquí para iniciar sesión con su cuenta de Google" arrow>
                        <Button>
                            <FaGooglePlusG size={48}></FaGooglePlusG>
                        </Button>
                    </Tooltip>
                    <p style={{ marginInline: 'auto', marginTop: 32, color: 'grey' }}>o registrate llenando el siguiente formulario</p> */}
                    <TextField
                        style={{
                            marginTop: 16, marginBottom: 16
                        }}
                        label="Nombre completo"
                        variant="outlined"
                        type="text"
                        value={name}
                        onChange={(event) => { setName(event.target.value) }}
                    />
                    <TextField
                        style={{
                            marginTop: 16, marginBottom: 16
                        }}
                        label="Email"
                        variant='outlined'
                        type="email"
                        value={email}
                        onChange={(event) => { setEmail(event.target.value) }}
                    />
                    <TextField
                        style={{
                            marginTop: 16, marginBottom: 16
                        }}
                        label="Teléfono: Ej. 3512345678"
                        variant="outlined"
                        type="text"
                        value={phone}
                        onChange={(event) => { setPhone(event.target.value) }}
                    />
                    <TextField
                        style={{
                            marginTop: 16, marginBottom: 16
                        }}
                        label="Contraseña"
                        variant="outlined"
                        type="password"
                        value={password}
                        onChange={(event) => { setPassword(event.target.value) }}
                    />
                    {msgError && (
                        <Typography fontSize={12} marginBottom={2} color={'red'}>{msgError}</Typography>
                    )}

                    <p style={{ color: 'gray', marginInline: 'auto', marginBottom: 64 }}>Ya tienes una cuenta? <Link to={'/login'}>Inicia Sesión!</Link></p>

                    <Button variant="contained" color={showAlert ? 'error' : 'primary'} onClick={RegisterAction} style={{ marginBottom: 16 }}>
                        Registrar
                    </Button>
                    {showAlert && (
                        <Alert severity="warning">
                            Por favor, completa todos los campos para poder registrarte
                        </Alert>
                    )}
                </div>

            </div>

            {/* Bienvenida */}
            <div style={{
                backgroundColor: '#009688',
                display: (isLargeScreen ? 'flex' : 'none'),
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40%',
                minWidth: 600,
                paddingInline: 64,
                boxSizing: 'border-box'
            }}>
                <div style={{ flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p style={{
                        color: 'white',
                        color: '#b2dfdb',
                        fontWeight: '500',
                        // fontSize: 56,
                        fontSize: 72,
                    }}>
                        Socialize
                    </p>
                </div>
                <div style={{ flex: 3, textAlign: 'center' }}>

                    <p style={{
                        color: 'white',
                        fontWeight: '500',
                        fontSize: 48,
                    }}>¡Qué Ansiedad!</p>
                    <p style={{
                        color: '#e0e0e0',
                        fontSize: 24,
                        marginTop: 32,
                        marginHorizontal: 64,
                        textAlign: 'center',
                        fontWeight: '300'
                    }}>Estas a la vuelta de la esquina de acceder a todas las funcionalidades, completa todos los campos para liberar todo el potencial que te ofrecemos!</p>
                </div>
            </div>




            <Modal
                open={openModal}
                onClose={() => { setOpenModal(false) }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: (isLargeScreen ? 400 : 300),
                    bgcolor: 'background.paper',
                    // border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '0.5em'
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Ya existe un usuario registrado con ese mail.
                    </Typography>


                    <Button variant="contained" color='success' onClick={() => { navigate("/login") }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300), marginBottom: 16 }}>
                        OK
                    </Button>
                </Box>
            </Modal>
            <Snackbar
                open={openUpdateSnackbar}
                autoHideDuration={6000}
                onClose={() => setOpenUpdateSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={() => setOpenUpdateSnackbar(false)} 
                    severity="info" 
                    sx={{ width: '100%' }}
                >
                    ¡Hay una nueva actualización disponible!
                </Alert>
            </Snackbar>

        </div>



    );


}


export default Register;